/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { Box, MenuItem, Select, Modal, Radio, Grid, Button, Tooltip, FormControlLabel, RadioGroup, Divider } from '@mui/material';
import { filter, get, isEmpty, uniqBy } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import './dosing.scss';
import { chemical_inputs } from './formdata';
import { getBorderColor } from '../../shared/utils';

const DosingInput = (props) => {
  const { visibleDosing, handleCloseDosing, dosingDetails, disabledStripperAndExplorerTab, inputOutputFlag, setInputOutputFlag, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [chemicalName, setChemicalName] = useState('');
  const [suppliedForm, setSuppliedForm] = useState('');
  const [formoptions, setFormOptions] = useState([]);
  const [radiovalue, setRadioValue] = useState('');
  const [safefact, setSafeFact] = useState(1.1);
  const [usage, setUsage] = useState(100);
  const [disabled, setDisabled] = useState(true);
  const [displayRadio, setDisplayRadio] = useState('flex');
  const [displayField, setDisplayField] = useState('none');
  const [hardleak, setHardLeak] = useState('');
  const chemicalNames = uniqBy(chemical_inputs, 'name');
  const [suppcon, setSuppCon] = useState('');
  const [metcon, setMetCon] = useState('');
  const [suppgrav, setSuppGrav] = useState('');
  const [metgrav, setMetGrav] = useState('');
  const [targetph, setTargetPH] = useState('');
  const [targetalkalinity, setTargetAlkalinity] = useState('');
  const [targetlsi, setTargetLSI] = useState('');
  const [doserate, setDoseRate] = useState('');
  const [suppvol, setSuppVol] = useState('');
  const [metvol, setMetVol] = useState('');
  const [safefactvol, setSafeFactVol] = useState('');
  const [volrate, setVolRate] = useState('');
  const [massrate, setMassRate] = useState('');
  const [dosrate, setDosRate] = useState('');
  const [units, setUnits] = useState(defaultUnitValues);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const getDosingName = () => {
    let dosingName = '';
    const local = localStorage.getItem(dosingDetails.id);
    if (local) {
      dosingName = ` - ${local}`;
    } else {
      dosingName = ` - Chemical Dosing ${Number(get(dosingDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return dosingName;
  };
  const submitForm = (isclose = true) => {
    if (chemicalName === '' || (suppliedForm === '' && chemicalName !== 'Sodium Cycle Softener') ||
      (radiovalue === '' && chemicalName !== 'Sodium Cycle Softener') || (hardleak === '' && chemicalName === 'Sodium Cycle Softener') ||
      (doserate === '' && radiovalue === 'Dosage Rate') || (targetph === '' && radiovalue === 'Target pH') ||
      (targetlsi === '' && radiovalue === 'Target LSI') || (targetalkalinity === '' && radiovalue === 'Target Alkalinity') ||
      (metcon === '' && chemicalName !== 'Sodium Cycle Softener') || (suppcon === '' && chemicalName !== 'Sodium Cycle Softener') ||
      (safefact === '' && chemicalName !== 'Sodium Cycle Softener') || (usage === '' && chemicalName !== 'Sodium Cycle Softener')) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Please enter the required fields'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      localStorage.setItem('dosingapply', 0);
    }
    else {
      const inputState = {
        'Feed': [1], 'Waste': [], 'Product': [2], 'Unit Type': 'Chemical_Dosing',
        'name': `Chemical Dosing ${Number(get(dosingDetails, 'id', '').split('_')[1]) + 1}`, 'dosing_chemical': chemicalName,
        'supplied_form': suppliedForm, 'solution_density_metered': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(metgrav),
        'solution_density_supplied': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(suppgrav),
        'concentration_supplied': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(suppcon),
        'concentration_metered': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(metcon),
        'target_pH': (radiovalue !== 'Target pH') ? 'None' : Number(targetph),
        'target_alk': (radiovalue !== 'Target Alkalinity') ? 'None' : Number(targetalkalinity),
        'dosage_rate': (radiovalue !== 'Dosage Rate') ? 'None' : Number(doserate),
        'hardness_leakage': (displayField === 'none') ? 'None' : Number(hardleak),
        'target_LSI': (radiovalue !== 'Target LSI') ? 'None' : Number(targetlsi),
        'usage': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(usage),
        'safety_factor': (chemicalName === 'Sodium Cycle Softener') ? 'None' : Number(safefact)
      };
      saveFormDataInLocalStorage({ record: inputState, type: 'Chemical_Dosing', id: dosingDetails.id, item: 'dosing-dict' });
      localStorage.setItem('dosingapply', 1);
      if (isclose)
        handleCloseDosing();
      getBorderColor(dosingDetails.id);
      setokbuttonFormAutoSave(true);
      if (isShowErrorMessage) {
        localStorage.setItem('globalExitBtn', 'true');
      }
    }
  };

  const handleClose_Dosing = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseDosing();
  };

  const handleCloseDosingModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClose_Dosing(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseDosing();
    };
  };
  function handleFormChange(e) {
    const supplu_val = e.target ? e.target.value : e;
    if (supplu_val === '') {
      setSuppliedForm(supplu_val);
      setMetCon('');
      setMetGrav('');
      setSuppCon('');
      setSuppGrav('');
      setRadioValue('');
      setDisabled(true);
    } else {
      setSuppliedForm(supplu_val);
      const input_fields = filter(chemical_inputs, { form: supplu_val });
      setSuppCon(input_fields[0].suppcon);
      setMetCon(input_fields[0].metcon);
      setSuppGrav(input_fields[0].suppgrav);
      setMetGrav(input_fields[0].metgrav);
      if (input_fields[0].suppcon === '' && input_fields[0].metcon === '' &&
        input_fields[0].suppgrav === '' && input_fields[0].metgrav === '') {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
    disabledStripperAndExplorerTab();
  }
  function handleChange(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value !== '') {
      setChemicalName(e.target.value); // updating chemical name
      setFormOptions(filter(chemical_inputs, { name: e.target.value })); // updating data in supplied forms
      if (e.target.value === 'Sodium Cycle Softener') { // checking for value 'Sodium Cycle Softener'
        const input_fields = filter(chemical_inputs, { name: e.target.value });
        setMetCon(input_fields[0].metcon);
        setMetGrav(input_fields[0].metgrav);
        setSuppCon(input_fields[0].suppcon);
        setSuppGrav(input_fields[0].suppgrav);
        setDisplayField('flex'); // showing hardness Leakage
        setRadioValue(''); // removing value target PH and dosage rate
        setSuppliedForm(''); // removing value Supplied Form
        setDisplayRadio('none'); // removing Supplied Form, Sulfuric Acid , Supplied Concentration, Metered Concentration
      }
      else {
        setDisabled(true);
        setDisplayField('none'); // removing hardness Leakage
        setRadioValue(''); // removing value target PH and dosage rate
        setDisplayRadio('flex');// showing Supplied Form, Sulfuric Acid , Supplied Concentration, Metered Concentration
        setSuppliedForm(filter(chemical_inputs, { name: e.target.value })[0].form); // select value for dropdown
        handleFormChange(filter(chemical_inputs, { name: e.target.value })[0].form); // updating values chemical dosing inputs
      }
    }
    else {
      setChemicalName('');
      setSuppliedForm('');
      setFormOptions([]);
      setMetCon('');
      setMetGrav('');
      setSuppCon('');
      setSuppGrav('');
      setRadioValue('');
      setDisabled(true);
      disabledStripperAndExplorerTab();
      setDisplayField('none');
      setDisplayRadio('flex');
      setHardLeak('');
    }
  }
  function handleClick(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (chemicalName === '') {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Please enter the chemical name'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  }
  const clearForm = () => {
    setChemicalName('');
    setSuppliedForm('');
    setFormOptions([]);
    setRadioValue('');
    setMetCon('');
    setMetGrav('');
    setSuppCon('');
    setSuppGrav('');
    setHardLeak('');
    setDisplayField('none');
    setDisplayRadio('flex');
    setDisabled(true);
  };
  const handleRadio = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setRadioValue(e.target.value);
    disabledStripperAndExplorerTab();
  };
  function changeDose(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0)
      setDoseRate(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Dosage Rate must be positive'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changePh(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0 && e.target.value <= 14) {
      setTargetPH(e.target.value);
    }
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('pH must be between 0 and 14'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeLSI(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= -3 && e.target.value <= 3) {
      setTargetLSI(e.target.value);
    }
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('LSI must be between -3 and 3'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeAlkalinity(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setTargetAlkalinity(e.target.value);
    disabledStripperAndExplorerTab();
  }
  function changeSafeFact(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0)
      setSafeFact(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Safety Factor  must be positive'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeUsage(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0 && e.target.value <= 100)
      setUsage(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Usage must be between 0 and 100'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeSuppCon(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0 && e.target.value <= 100)
      setSuppCon(e.target.value);
    else {
      e.target.blur();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Supplied Concentration must be between 0 and 100'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeMetCon(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0 && e.target.value <= 100)
      setMetCon(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Metered Concentration must be between 0 and 100'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeSuppGrav(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0)
      setSuppGrav(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Specific Gravity at supplied Concentration must be positive'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeMetGrav(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= 0)
      setMetGrav(e.target.value);
    else {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Metered Gravity at Supplied Concentration must be a positive value'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    disabledStripperAndExplorerTab();
  }
  function changeHardLeak(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value < 0) {
      e.preventDefault();
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Hardness Leakage must be positive'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else {
      setHardLeak(e.target.value);
    }
  }
  function fetchFormDatafromLocalStorage(localdata) {
    if (localdata.Chemical_Dosing[dosingDetails.id]) {
      const data = localdata.Chemical_Dosing[dosingDetails.id];
      setChemicalName(data.dosing_chemical);
      if (data.dosing_chemical === 'Sodium Cycle Softener') {
        setDisplayField('flex');
        setDisplayRadio('none');
        setRadioValue('');
        setHardLeak(data.hardness_leakage);
      }
      setFormOptions(filter(chemical_inputs, { name: data.dosing_chemical }));
      setSuppliedForm(data.supplied_form);
      if (data.supplied_form.substring(0, 7) === 'Generic')
        setDisabled(false);
      setSuppCon((data.concentration_supplied === 'None') ? '' : data.concentration_supplied);
      setMetCon((data.concentration_metered === 'None') ? '' : data.concentration_metered);
      setSuppGrav((data.solution_density_supplied === 'None') ? '' : data.solution_density_supplied);
      setMetGrav((data.solution_density_metered === 'None') ? '' : data.solution_density_metered);
      if (data.target_pH !== 'None') {
        setRadioValue('Target pH');
        setTargetPH(data.target_pH);
      }
      if (data.dosage_rate !== 'None') {
        setRadioValue('Dosage Rate');
        setDoseRate(data.dosage_rate);
      }
      if (data.target_LSI !== 'None') {
        setRadioValue('Target LSI');
        setTargetLSI(data.target_LSI);
      }
      if (data.target_alk !== 'None') {
        setRadioValue('Target Alkalinity');
        setTargetAlkalinity(data?.target_alk || 'None');
      }
      setSafeFact((data.safety_factor === 'None') ? 1.1 : data.safety_factor);
      setUsage((data.usage === 'None') ? 100 : data.usage);
    }
  }
  const calculateFlowSheetforDosing = (str) => {
    submitForm(false);
    setIsShowErrorMessage(false);
    const appycheck = setInterval(() => {
      const apply = localStorage.getItem('dosingapply');
      if (apply === '0' || apply === '1') {
        clearInterval(appycheck);
        localStorage.removeItem('dosingapply');
      }
      if (apply === '1') {
        setInputOutputFlag(false);
        document.getElementById(`${str}_data`).click();
      }
    }, 100);
  };
  function fetchOutputData() {
    if (localStorage.getItem('cd-output-dict')) {
      const outputData = JSON.parse(localStorage.getItem('cd-output-dict'));
      const resdata = outputData.Chemical_Dosing[dosingDetails.id]?.output_user; // checking output_user info in existing cd-output-dict dictonery
      if (resdata) { // checking for data is existing in resdata
        setDosRate(Number(resdata.dosage_rate).toFixed(2));
        setMassRate(Number(resdata.mass_rate).toFixed(2));
        if (chemicalName !== 'Sodium Cycle Softener') {
          setVolRate(Number(resdata.volume_rate).toFixed(4));
          setSuppVol(Number(resdata.supplied_volume).toFixed(4));
          setMetVol(Number(resdata.metered_volume).toFixed(4));
          setSafeFactVol(Number(resdata.safety_factor_volume).toFixed(4));
        }
      }
    }
  }
  useEffect(() => {
    fetchOutputData();
  }, [inputOutputFlag]);
  useEffect(() => {
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('system-units')));
    }
    if (localStorage.getItem('dosing-dict')) {
      const localdata = JSON.parse(localStorage.getItem('dosing-dict'));
      fetchFormDatafromLocalStorage(localdata);
    }
    fetchOutputData();
  }, []);
  return (
    <Modal hideBackdrop open={visibleDosing} onClose={handleCloseDosingModal} className='splitter-modal'>
      <Box>
        <Rnd default={{
          width: '55%',
          x: ((window.innerWidth / 2) - ((60 * (window.innerWidth / 100)) / 2)),
          y: ((window.innerHeight / 2) - ((60 * (window.innerHeight / 100)) / 2)),
        }} enableResizing={{
          bottom: false, bottomLeft: false, bottomRight: false,
          left: true, right: true,
          top: false, topLeft: false, topRight: false
        }} allowAnyClick enableUserSelectHack={false} resizeHandleStyles={{ 'right': { 'width': '5px' } }} minWidth='40%' cancel='.no_drag, .MuiSelect-select, .normal-font, .MuiOutlinedInput-notchedOutline .MuiToggleButton-primary, .dosing-select, .cancel-handle, .MuiButton-contained' className='box-model'
        >
          <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
          <Grid container className='Chem_dosing-grid-container'>
            <Grid item xs={12} className="model_header">
              <div className="model_header_text S_heading" id='roFeedName'>{`Chemical Dosing ${getDosingName()}`}
              </div>
              <div className="ro-close-icon no_drag">
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={handleCloseDosingModal}
                    style={{ width: '14px', padding: '11px' }} className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='model_body'>
              <Grid container>
                <Grid item xs={12} className='dosing_chemical_selection'>
                  <Grid container>
                    <Grid item xs={12}>
                      <div className='no_drag S_Bold'>{translateObject('Chemical Selection')}</div>
                    </Grid>
                    <Grid item xs={12} className='dosing_chemical_section'>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={6} sm={12}>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox'>
                              <Grid item xs={3.5}>
                                <div className='no_drag S_Regular'>{translateObject('Chemical')}</div>
                              </Grid>
                              <Grid item xs={8.5} className='dosing-select no_drag'>
                                <Select className='Default_input no_drag' fullWidth style={{ fontSize: 12 }}
                                  value={chemicalName} onChange={(e) => { handleChange(e); }}>
                                  <MenuItem value='' onClick={clearForm}>Select</MenuItem>
                                  {chemicalNames.map((names) => {
                                    return (
                                      <MenuItem key={`aa${Math.random().toString(36).slice(2, 7)}`} value={names.name}>
                                        <span dangerouslySetInnerHTML={{ __html: translateObject(names.name) }} />
                                      </MenuItem>);
                                  })}
                                </Select>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox' style={{ display: displayRadio }}>
                              <Grid item xs={3.5}>
                                <div className='no_drag S_Regular'>{translateObject('Supplied Form')}</div>
                              </Grid>
                              <Grid item xs={8.5} className='dosing-select'>
                                <Select className='Default_input supplied_form' value={suppliedForm} style={{ fontSize: 12 }}
                                  fullWidth onFocus={(e) => { handleClick(e); }}
                                  onChange={(e) => { handleFormChange(e); }}
                                  disabled={!((chemicalName !== '' && chemicalName !== 'Sodium Cycle Softener'))}
                                  placeholder='Select Supplied Form'>
                                  <MenuItem value='' onClick={setSuppliedForm}>{translateObject('Select')}</MenuItem>
                                  {formoptions.map((options) => {
                                    return (
                                      <MenuItem key={`aa${Math.random().toString(36).slice(2, 7)}`} value={options.form}>
                                        {options.form}
                                      </MenuItem>);
                                  })}
                                </Select>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={6} md={6} sm={12}>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                              <Grid item xs={9.5}>
                                <div className='normal-font f-left no_drag S_Regular'>{translateObject('Supplied Concentration')}</div>
                              </Grid>
                              <Grid item xs={2} className='dosing-select'>
                                <input type='number' id='suppcon' value={suppcon} onChange={(e) => { changeSuppCon(e); }}
                                  onFocus={e => e.target.select()}
                                  disabled={disabled} className='cancel-handle Form_Input_design' required />
                              </Grid>
                              <Grid item xs={0.5}>
                                <div className='no_drag Form_Input_design_Units'>%</div>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                              <Grid item xs={9.5}>
                                <div className='normal-font f-left no_drag S_Regular'>{translateObject('Metered Concentration')}</div>
                              </Grid>
                              <Grid item xs={2}>
                                <input type='number' id='metcon' value={metcon} onChange={(e) => { changeMetCon(e); }}
                                  onFocus={e => e.target.select()}
                                  disabled={disabled} className='cancel-handle Form_Input_design' required />
                              </Grid>
                              <Grid item xs={0.5}>
                                <div className='no_drag Form_Input_design_Units'>%</div>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                              <Grid item xs={9.5}>
                                <div className='normal-font f-left no_drag S_Regular'>{translateObject('Specific Gravity at supplied Concentration')}
                                </div>
                              </Grid>
                              <Grid item xs={2}>
                                <input type='number' id='suppgrav' value={suppgrav} onChange={(e) => { changeSuppGrav(e); }}
                                  onFocus={e => e.target.select()}
                                  disabled={disabled} className='cancel-handle Form_Input_design' required />
                              </Grid>
                              <Grid item xs={0.5} />
                            </Grid>
                          </Grid>
                          <Grid item xs={12} className='input_dosing_select'>
                            <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                              <Grid item xs={9.5}>
                                <div className='normal-font f-left no_drag S_Regular'>{translateObject('Specific Gravity at metered Concentration')}
                                </div>
                              </Grid>
                              <Grid item xs={2}>
                                <input type='number' id='metgrav' value={metgrav} onChange={(e) => { changeMetGrav(e); }}
                                  onFocus={e => e.target.select()}
                                  disabled={disabled} className='cancel-handle Form_Input_design' required />
                              </Grid>
                              <Grid item xs={0.5} />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} className='dosing_controls'>
                  <Grid container>
                    <Grid item xs={12} className='no_drag S_Bold'>{translateObject('Dosing Control')}</Grid>
                    <Grid item xs={12} className='input_dosing_select'>
                      <Grid container className='dosing-textbox' style={{ display: displayRadio }}>
                        <Grid item xs={12}>
                          <RadioGroup row aria-labelledby='demo-row-radio-buttons-group-label' name='row-radio-buttons-group'
                            className='radio-group-container' value={radiovalue} onChange={handleRadio}>
                            {chemicalName !== 'Sodium Sulfate' && <FormControlLabel name='targetph' value='Target pH' control={<Radio />}
                              label={translateObject('Target pH')}
                              labelPlacement='end'
                              className='cancel-handle S_Regular'
                            />}
                            {chemicalName !== 'Sodium Sulfate' && <FormControlLabel name='targetlsi' value='Target LSI' control={<Radio />}
                              label={translateObject('Target LSI')}
                              labelPlacement='end'
                              className='cancel-handle S_Regular'
                            />}
                            <FormControlLabel name='doserate' value='Dosage Rate' control={<Radio />}
                              label={translateObject('Dosage Rate')}
                              labelPlacement='end'
                              className='cancel-handle S_Regular'
                            />
                            {chemicalName === 'Calcium Carbonate' && <FormControlLabel name='targetalkalinity' value='Target Alkalinity' control={<Radio />}
                              label={translateObject('Target Alkalinity')}
                              labelPlacement='end'
                              className='cancel-handle S_Regular'
                            />}
                          </RadioGroup>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} className='dosing_control_feild'>
                      <Grid container spacing={2}>
                        <Grid item xs={6} className='input_dosing_select' style={{ display: displayField }}>
                          <Grid container className='dosing-textbox' style={{ display: displayField, alignItems: 'center' }}>
                            <Grid item xs={5}>
                              <div className='normal-font f-left no_drag S_Regular'>{translateObject('Hardness Leakage')}</div>
                            </Grid>
                            <Grid item xs={4}>
                              <input type='number' id='hardleak' value={hardleak} onFocus={e => e.target.select()}
                                onChange={(e) => { changeHardLeak(e); }} className='cancel-handle Form_Input_design' required />
                            </Grid>
                            <Grid item xs={3}>
                              <div className='no_drag Form_Input_design_Units'>ppm CaCO3</div>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={(radiovalue === 'Target Alkalinity') ? 6 : 6} className='input_dosing_select' style={(radiovalue === '') ? { display: 'none' } : {
                          display: 'flex', alignItems: 'center'
                        }}>
                          <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='normal-font f-left no_drag S_Regular'>{radiovalue}</div>
                            <Grid item xs={0.5} />
                            <Grid item xs={3.5}>
                              <input type='number' id='doseph' value={(radiovalue === 'Dosage Rate') ? doserate : ((radiovalue === 'Target pH') ? targetph : ((radiovalue === 'Target Alkalinity') ? targetalkalinity : targetlsi))} onFocus={e => e.target.select()}
                                onChange={(radiovalue === 'Dosage Rate') ? (e) => { changeDose(e); } : ((radiovalue === 'Target pH') ? (e) => { changePh(e); } : ((radiovalue === 'Target Alkalinity') ? (e) => { changeAlkalinity(e); } : (e) => { changeLSI(e); }))}
                                className='Form_Input_design cancel-handle' required />
                            </Grid>
                            <Grid item xs={4}>
                              <div className='no_drag Form_Input_design_Units'>{(radiovalue === 'Dosage Rate') ? 'mg/l' :
                                ((radiovalue === 'Target Alkalinity') ? 'ppm CaCO3' : '')}</div>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={3} md={3} sm={12} className='input_dosing_select'>
                          <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                            <Grid item xs={6}>
                              <div className='normal-font f-left no_drag S_Regular'>{translateObject('Safety Factor')}</div>
                            </Grid>
                            <Grid item xs={0.5} />
                            <Grid item xs={4.5}>
                              <input type='number' id='safefact' value={safefact} onChange={(e) => { changeSafeFact(e); }}
                                onFocus={e => e.target.select()} className='cancel-handle Form_Input_design' required />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={3} md={3} sm={12} className='input_dosing_select'>
                          <Grid container className='dosing-textbox' style={{ display: displayRadio, alignItems: 'center' }}>
                            <Grid item xs={3}>
                              <div className='normal-font f-left no_drag S_Regular'>{translateObject('Usage')}</div>
                            </Grid>
                            <Grid item xs={0.5} />
                            <Grid item xs={4.5}>
                              <input type='number' id='usage' value={usage} onChange={(e) => { changeUsage(e); }}
                                onFocus={e => e.target.select()} className='Form_Input_design cancel-handle' required />
                            </Grid>
                            <Grid item xs={1}>
                              <div className='no_drag Form_Input_design_Units'>%</div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className='dosing-output-form'>
                <Grid item xs={1} className='no_drag S_Bold'>{translateObject('Output')}</Grid>
                <Grid item xs={11}>
                  <Grid container spacing={2}>
                    <Grid item xs={5.5} md={5.5} sm={12}>
                      <Grid item xs={12} className='input_dosing_select'>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left no_drag S_Regular'>{translateObject('Dosage Rate')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='dosrate' value={dosrate}
                              className='Form_Input_design cancel-handle' disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>mg/l</div>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className='input_dosing_select'>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left no_drag S_Regular'>{translateObject('Mass flow Rate')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='massrate' value={massrate}
                              className='Form_Input_design cancel-handle' disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>kg/day</div>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className='input_dosing_select'
                        style={{ display: displayRadio, alignItems: 'center' }}>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left  no_drag S_Regular'>{translateObject('Volume Flow Rate')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='volrate' value={volrate}
                              className='Form_Input_design cancel-handle' disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>{units.flow}</div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6.5} md={5.5} sm={12}>
                      <Grid item xs={12} className='input_dosing_select'
                        style={{ display: displayRadio, alignItems: 'center' }}>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left no_drag S_Regular'>{translateObject('Average Consumption as metered')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='metvol' value={metvol} className='Form_Input_design cancel-handle'
                              disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>{units.flow}</div>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className='input_dosing_select'
                        style={{ display: displayRadio, alignItems: 'center' }}>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left no_drag S_Regular'>{translateObject('Average Consumption as Supplied')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='suppvol' value={suppvol}
                              className='Form_Input_design cancel-handle' disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>{units.flow}</div>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className='input_dosing_select'
                        style={{ display: displayRadio, alignItems: 'center' }}>
                        <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                          <Grid item xs={7}>
                            <div className='normal-font f-left no_drag S_Regular'>{translateObject('Supplied/Delivered consumption with safety factor')}</div>
                          </Grid>
                          <Grid item xs={3} className='dosing-select'>
                            <input type='number' id='safefactvol' value={safefactvol}
                              className='Form_Input_design cancel-handle' disabled />
                          </Grid>
                          <Grid item xs={2}>
                            <div className='no_drag Form_Input_design_Units'>{units.flow}</div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="bottom-button">
                  <div>
                    <Button
                      size="small"
                      variant="contained"
                      className={`btn-auto-width M_Bold ${!inputOutputFlag ? 'Primary-Disabled Forground-Text-Disabled' : 'backgroud-primary-default forground-text-primary-inverse'}`}
                      disabled={!inputOutputFlag}
                      onClick={() => { calculateFlowSheetforDosing('calculate'); }}
                    >
                      {translateObject('Apply')}
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      size="small"
                      className="btn-auto-width M_Bold Secondary-Default secoundary-text-color-Primary-default"
                      style={{ width: '120px', marginRight: 15 }}
                      onClick={handleCloseDosingModal}>
                      {translateObject('Cancel')}
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      className="btn-auto-width M_Bold backgroud-primary-default forground-text-primary-inverse"
                      onClick={submitForm}
                      style={{ width: '120px' }}>
                      {translateObject('OK')}
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default DosingInput;
